<template>
  <v-app-bar app dense color="blue darken-1" height="150px">
    <v-app-bar-nav-icon
      @click="drawer = true"
      class="d-flex d-md-none white--text"
    ></v-app-bar-nav-icon>
    <div class="d-flex flex-column display-2">
      <div class="d-none d-md-block mt-10">
        <template v-for="item in headerLinks">
          <v-btn
            :key="item.title"
            v-if="item.show"
            elevation="0"
            :to="item.to"
            plain
            text
            class="font-weight-bold white--text text-body-2 hover_effect ml-2"
          >
            <v-icon class="pl-2">{{ item.icon }}</v-icon>
            {{ $_t(`components.app.header.${item.title}`) }}
          </v-btn>
        </template>
      </div>
    </div>
    <div class="d-none d-sm-block">
      <h4 class="text-body-1 header-title text-sm-h6 text-md-h5 neon">
        مهرآوران دانش پژوهان البرز
      </h4>
    </div>
    <v-spacer></v-spacer>
    <router-link to="/">
      <v-img
        to="/"
        width="80px"
        height="89px"
        src="@/assets/images/icon.png"
      ></v-img>
    </router-link>
    <v-tooltip bottom v-if="!user">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          dark
          icon
          v-bind="attrs"
          v-on="on"
          :to="{ name: 'auth.login' }"
          class="my-auto"
        >
          <v-icon>mdi-login</v-icon>
        </v-btn>
      </template>
      <span>{{ $_t("components.app.header.login") }}</span>
    </v-tooltip>
    <span v-if="!user" class="white--text">/</span>
    <v-tooltip bottom v-if="!user">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          dark
          v-bind="attrs"
          class="my-auto"
          v-on="on"
          :to="{ name: 'auth.register' }"
        >
          <v-icon>mdi-account-plus-outline</v-icon>
        </v-btn>
      </template>
      <span>{{ $_t("components.app.header.register") }}</span>
    </v-tooltip>
    <v-tooltip bottom v-if="user">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon dark v-bind="attrs" v-on="on" @click="logout" class="mx-4">
          <v-icon>mdi-logout</v-icon>
        </v-btn>
      </template>
      <span>{{ $_t("components.app.header.logout") }}</span>
    </v-tooltip>

    <v-navigation-drawer
      width="100%"
      overlay-opacity="0.8"
      right
      v-model="drawer"
      temporary
      app
    >
      <span class="d-flex justify-end">
        <v-icon
          large
          color="black darken-0"
          class="font-weight-bold"
          @click="drawer = false"
        >
          mdi-close
        </v-icon>
      </span>
      <v-list nav width="60%" class="mx-auto">
        <v-list-item-group>
          <template v-for="item in headerLinks">
            <v-list-item v-if="item.show" :key="item.title" :to="item.to">
              <v-list-item-title>
                <v-icon class="pl-2">{{ item.icon }}</v-icon>
                {{
                  $_t(`components.app.header.${item.title}`)
                }}</v-list-item-title
              >
            </v-list-item>
          </template>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </v-app-bar>
</template>

<script>
import { HEADER_LINKS } from "@/schema/navigation-drawer-link/NAV_LINKS";
import { mapGetters } from "vuex";
export default {
  name: "Header",
  data() {
    return {
      routes: HEADER_LINKS,
      drawer: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "authentication/user",
    }),
    headerLinks() {
      if (this.user) {
        return [
          { icon: "mdi-home", title: "home", to: "/", show: true },
          {
            icon: "mdi-shield-crown",
            title: "dashboard",
            to: { name: "dashboard.main" },
            show: !this.user.isAdmin,
          },
          {
            icon: "mdi-shield-crown",
            title: "admin",
            to: { name: "admin.main" },
            show: this.user.isAdmin,
          },
          {
            icon: "mdi-arrow-up-thick",
            title: "about_determining",
            to: { name: "about_determining" },
            show: true,
          },
          {
            icon: "mdi-chat-question",
            title: "what_determining",
            to: { name: "what_determining" },
            show: true,
          },
          {
            icon: "mdi-help-box",
            title: "condition",
            to: { name: "condition" },
            show: true,
          },
          {
            icon: "mdi-email-seal-outline",
            title: "application_certificate",
            to: { name: "application_certificate" },
            show: true,
          },
          {
            icon: "mdi-information-variant",
            title: "about_us",
            to: { name: "about" },
            show: true,
          },
          {
            icon: "mdi-account-box-outline",
            title: "contact_us",
            to: { name: "contact" },
            show: true,
          },
        ];
      }
      return [
        { icon: "mdi-home", title: "home", to: "/", show: true },
        {
          icon: "mdi-arrow-up-thick",
          title: "about_determining",
          to: { name: "about_determining" },
          show: true,
        },
        {
          icon: "mdi-chat-question",
          title: "what_determining",
          to: { name: "what_determining" },
          show: true,
        },
        {
          icon: "mdi-help-box",
          title: "condition",
          to: { name: "condition" },
          show: true,
        },
        {
          icon: "mdi-email-seal-outline",
          title: "application_certificate",
          to: { name: "application_certificate" },
          show: true,
        },
        {
          icon: "mdi-information-variant",
          title: "about_us",
          to: { name: "about" },
          show: true,
        },
        {
          icon: "mdi-account-box-outline",
          title: "contact_us",
          to: { name: "contact" },
          show: true,
        },
      ];
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("authentication/logout");
      setTimeout(() => {
        window.location.reload();
      }, 200);
    },
  },
};
</script>
<style>
.hover_effect {
  z-index: 2;
  font-weight: 600;
}

.hover_effect:after {
  content: "";
  height: 3px;
  left: 0;
  width: 1px;
  position: absolute;
  -webkit-transition: width 0.5s ease, background-color 0.5s ease;
  -moz-transition: width 0.5s ease, background-color 0.5s ease;
  -ms-transition: width 0.5s ease, background-color 0.5s ease;
  -o-transition: width 0.5s ease, background-color 0.5s ease;
  transition: width 0.5s ease, background-color 0.5s ease;
  right: 0;
  bottom: 0;
  margin: 0 auto;
}

.hover_effect:hover {
  color: white;
  -webkit-transition: color 0.5s ease;
  -moz-transition: color 0.5s ease;
  -ms-transition: color 0.5s ease;
  -o-transition: color 0.5s ease;
  transition: color 0.5s ease;
  cursor: pointer;
}

.hover_effect:hover:after,
.hover_effect:focus:after {
  width: 60%;
  background-color: white;
}
.neon {
  color: #fff;
  text-shadow: 0 0 5px #fff, 0 0 10px #fff, 0 0 20px #fff, 0 0 40px #0ff,
    0 0 80px #0ff, 0 0 90px #0ff, 0 0 100px #0ff, 0 0 150px #0ff;
}
.header-title {
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  top: 10%;
}
.v-overlay {
  z-index: 0 !important;
}
</style>
